/* Dedupe injected COD app buy buttons.
   Releasit sometimes injects its styled button twice on the same page (embed re-init).
   Keep exactly one — prefer the copy inside the product form (the one the app wires up) —
   and remove any extras, including ones injected late. */
(function(){
  function dedupe(){
    var btns=document.querySelectorAll('#rsi_buy_now_button,[id^="rsi_buy_now"]');
    if(btns.length<2) return;
    var keep=null;
    for(var i=0;i<btns.length;i++){ if(btns[i].closest('form')){ keep=btns[i]; break; } }
    if(!keep) keep=btns[0];
    for(var j=btns.length-1;j>=0;j--){
      if(btns[j]===keep) continue;
      var extra=btns[j], parent=extra.parentElement;
      extra.remove();
      /* drop an empty wrapper the app left behind, but never touch the form */
      if(parent&&!parent.children.length&&!parent.closest('form')&&parent!==document.body) parent.remove();
    }
  }
  function schedule(){
    dedupe();
    [500,1200,2500,4000,7000,12000].forEach(function(ms){ setTimeout(dedupe,ms); });
    if(window.MutationObserver){
      var pend=false;
      var mo=new MutationObserver(function(){ if(pend) return; pend=true;
        requestAnimationFrame(function(){ pend=false; dedupe(); }); });
      mo.observe(document.body,{childList:true,subtree:true});
      setTimeout(function(){ mo.disconnect(); dedupe(); },30000);
    }
  }
  if(document.readyState==='complete') schedule(); else window.addEventListener('load',schedule);
})();
